import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { LoadingBarService } from '@ngx-loading-bar/core';
import * as _ from 'lodash';

import Swal from 'sweetalert2';

import {
  HeaderService,
  ServiceOrderService,
  FiltersService
} from '../../../shared';

@Component({
  selector: 'app-service-order-new',
  templateUrl: './service-order-new.component.html',
  styleUrls: ['./service-order-new.component.scss']
})
export class ServiceOrderNewComponent implements OnInit {
  title = "NOVA ORDEM DE SERVIÇO";
  subtitle = "Utilize os campos abaixo para cadastrar uma nova ordem de serviço";
  urlBack = "/panel/service-order/list";

  newServiceOrder = this.fb.group ({
    cdBandeira: [''],
    cdFornecedor: [''],
    cdFilial: [''],
    cdTpServico: [''],
    quantidade: ['1'],
    items: this.fb.array([]),
    dsObservacao: [''],
    flNovaLoja: ['0']
  });

  flagsArr = [];
  storesArr = [];
  equipmentsArr = [];
  providersArr = [];
  servicesArr = [];
  arrayTemp = [];

  actualDate;
  id;

  cdOperador = localStorage.getItem('userId');
  
  constructor(
    private headerService: HeaderService,
    private loadingBarService: LoadingBarService,
    private filtersService: FiltersService,
    private serviceOrderService: ServiceOrderService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) { 
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {

    this.headerService.changeTitle('Nova ordem de serviço');
    this.headerService.changeSubtitle('');
    this.headerService.changeDatePicker(false);

    this.setActualDate();

    this.filtersService.listFlags().subscribe((response) => {
      this.flagsArr = response['data'];
    });

    this.filtersService.listServices().subscribe((response) => {
      this.servicesArr = response['data'];
    });

    this.filtersService.listEquipments(`?cdOperador=`+ this.cdOperador).subscribe((response) => {
      this.equipmentsArr = response['data'];
    });
  }

  getStores(providerId) {
    this.filtersService.listStores(`?cdLogomarca=${providerId}`).subscribe((response) => {
      this.storesArr = response['data'];
    });
  }

  getServiceProviders(equipmentId) {
    console.log(equipmentId)
    this.filtersService.listProviders(`?cdProduto=${equipmentId}`+`&cdOperador=`+ this.cdOperador).subscribe((response) => {
      this.providersArr = response['data'];
    });

    if(this.newServiceOrder.controls.flNovaLoja.value == '0') {

      let control = <FormArray>this.newServiceOrder.controls.items;

      control.controls = [];
  
      while (control.value.length !== 0) {
        control.removeAt(0)
      }

      control.push(
        this.fb.group({
          cdProduto: [equipmentId],
          qtItem: [1],
        })
      )
    }
  }

  getEquipments(providerId) {
    this.filtersService.listEquipments(`?cdFornecedor=${providerId}`).subscribe((response) => {
      this.equipmentsArr = response['data'];

      this.arrayTemp = [];
      this.newServiceOrder.controls.quantidade.setValue('1');

      this.equipmentsArr.forEach((equipamento) => {
        this.arrayTemp.push({equipamento, quantidade: 1, checked: true});
      })
    });
  }

  setActualDate() {
    let date = new Date(),
        day = ("0" + date.getDate()).slice(-2),
        month = ("0" + (date.getMonth() + 1)).slice(-2),
        year = date.getFullYear();

    this.actualDate = `${day}/${month}/${year}`;
  }

  resetValues() {
    this.newServiceOrder.patchValue({
      cdBandeira: "",
      cdFornecedor: "",
      cdFilial: "",
      cdTpServico: "",
      cdProduto: "",
      dsObservacao: ""
    });

    let control = <FormArray>this.newServiceOrder.controls.items;

    control.controls = [];

    while (control.value.length !== 0) {
      control.removeAt(0)
    }

  }

  outputEquipments(index, produto) {

    for (var i = 0, l = this.arrayTemp.length; i < l; i++) {
      if (this.arrayTemp[i].equipamento.cdProduto === produto.equipamento.cdProduto) {
        this.arrayTemp[i].quantidade = this.newServiceOrder.controls.quantidade.value;
          break;
      }
    }
  }

  toggleCheckbox(index, id) {

    for (var i = 0, l = this.arrayTemp.length; i < l; i++) {
      if (this.arrayTemp[i].equipamento.cdProduto === id) {
        this.arrayTemp[i].checked = !this.arrayTemp[i].checked
          break;
      }
    }
  }


  addNewServiceOrder() {
    this.loadingBarService.start();
    
    if(this.newServiceOrder.controls.flNovaLoja.value == '1') {

      let control = <FormArray>this.newServiceOrder.controls.items;
      control.controls = [];
    
      while (control.value.length !== 0) {
          control.removeAt(0)
      }
      
      this.arrayTemp.forEach((produto) => {
        if(produto.checked) {
          control.push(
            this.fb.group({
              cdProduto: [produto.equipamento.cdProduto],
              qtItem: [produto.quantidade],
            })
          )
        }
      })
    }

    this.serviceOrderService.addServiceOrders(this.newServiceOrder.value).subscribe((response) => {
      this.loadingBarService.complete();

      this.resetValues();

      Swal({
        type: "success",
        title: "Ordem de serviço cadastrado ",
        text:  `Ordem de Serviço nº ${response['data']['idFsRequisicao']} criada com sucesso`,
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      });
    });
  }

  newStore(val) {
    this.newServiceOrder.patchValue({
      cdFornecedor: "",
      cdProduto: ""
    });

    let control = <FormArray>this.newServiceOrder.controls.items;
    control.controls = [];
  
    while (control.value.length !== 0) {
        control.removeAt(0)
    }

    if (val == "1") {

      this.newServiceOrder.controls.cdTpServico.setValue('1');

      this.equipmentsArr = [];

      this.filtersService.listProviders().subscribe((response) => {
        this.providersArr = response['data'];
      });
    } else {
      this.providersArr = [];

      this.filtersService.listEquipments().subscribe((response) => {
        this.equipmentsArr = response['data'];
      });
    }
  }

}
